import axios from 'axios';
import { api, tokenStore } from './apiService';

const API_BASE_URL = import.meta.env.VITE_API_URL ?? '/api';

export interface AuthUser {
  id: string;
  email: string;
}

export interface AuthResponse {
  access_token: string;
  user: AuthUser;
}

export const authService = {
  async register(email: string, password: string): Promise<AuthResponse> {
    const { data } = await axios.post<AuthResponse>(
      `${API_BASE_URL}/auth/register`,
      { email, password },
      { withCredentials: true }
    );
    tokenStore.set(data.access_token);
    return data;
  },

  async login(email: string, password: string): Promise<AuthResponse> {
    const { data } = await axios.post<AuthResponse>(
      `${API_BASE_URL}/auth/login`,
      { email, password },
      { withCredentials: true }
    );
    tokenStore.set(data.access_token);
    return data;
  },

  async logout(): Promise<void> {
    try {
      await api.post('/auth/logout');
    } finally {
      tokenStore.clear();
    }
  },

  async refresh(): Promise<AuthResponse | null> {
    try {
      const { data } = await axios.post<AuthResponse>(
        `${API_BASE_URL}/auth/refresh`,
        {},
        { withCredentials: true }
      );
      tokenStore.set(data.access_token);
      return data;
    } catch {
      tokenStore.clear();
      return null;
    }
  },
};
